import { z } from 'zod';

export type InsightsReportAdLevel = 'account' | 'campaign' | 'adset' | 'ad';
export type AttrDuration = z.infer<typeof AttrDurationDTO>;
export const AttrDurationDTO = z.union([
  z.literal('1d'),
  z.literal('7d'),
  z.literal('28d'),
]);
export type InsightAttributionSourceType = 'online' | 'offline';

export interface DailyAttributionTotal {
  day: string;
  conversions: number;
}

export const exampleDailyAttributionTotal: DailyAttributionTotal = {
  day: '2021-01-01',
  conversions: 2,
};

export type AttrWindowLevel = z.infer<typeof AttrWindowLevelDTO>;

export const AttrWindowLevelDTO = z.object({
  view: AttrDurationDTO,
  click: AttrDurationDTO,
});

export const exampleAttrWindowLevel: AttrWindowLevel = {
  view: '1d',
  click: '7d',
};

export type AttrWindowsBySourceType = z.infer<
  typeof AttrWindowsBySourceTypeDTO
>;

export const AttrWindowsBySourceTypeDTO = z.object({
  online: AttrWindowLevelDTO,
  offline: AttrWindowLevelDTO,
});

export const exampleAttrWindowsBySourceType: AttrWindowsBySourceType = {
  online: {
    view: '1d',
    click: '7d',
  },
  offline: {
    view: '28d',
    click: '28d',
  },
};

export interface FacebookStats {
  reach: number;
  frequency: number;
  spend: number;
  impressions: number;
}

export const exampleFacebookStats: FacebookStats = {
  reach: 152544,
  frequency: 3.883988,
  spend: 193.58,
  impressions: 592479,
};
